export default "__VITE_ASSET__CPaveq4A__"